import { css } from 'styled-components';

export const THEME_CSS_VARIABLES = css`
  :root {
    /* ========================================
       NEW DESIGN SYSTEM - Indigo/Slate palette
       ======================================== */

    /* Primary - Indigo */
    --colors-brand-primary: #4f46e5;
    --colors-brand-primary-hover: #4338ca;
    --colors-brand-primary-active: #3730a3;
    --colors-brand-primary-disabled: #a5b4fc;
    --colors-brand-primary-opaque: #eef2ff;
    --colors-brand-primary-text: #ffffff;

    /* Secondary - Violet */
    --colors-brand-secondary: #7c3aed;
    --colors-brand-secondary-hover: #6d28d9;
    --colors-brand-secondary-active: #5b21b6;
    --colors-brand-secondary-disabled: #c4b5fd;
    --colors-brand-secondary-opaque: #f5f3ff;
    --colors-brand-secondary-text: #ffffff;

    /* Primary scale - Indigo */
    --colors-primary-100: #4f46e5;
    --colors-primary-80: #6366f1;
    --colors-primary-60: #818cf8;
    --colors-primary-40: #a5b4fc;
    --colors-primary-20: #eef2ff;

    /* Secondary scale - Violet */
    --colors-secondary-100: #7c3aed;
    --colors-secondary-80: #8b5cf6;
    --colors-secondary-60: #a78bfa;
    --colors-secondary-40: #c4b5fd;

    /* Thumbnail text */
    --colors-thumbnail-text: #ffffff;

    /* Layout dimensions */
    --layout-sidebar-width: 4rem;
    --layout-header-height: 64px;
    --layout-interaction-panel-width: 496px;
    --layout-interaction-panel-collapsed: 86px;
  }

  body[data-theme='light'],
  body[data-theme='dark'] {
    /* Foreground - Slate (text colors) */
    --colors-foreground-100: #0f172a;
    --colors-foreground-80: #1e293b;
    --colors-foreground-60: #475569;
    --colors-foreground-40: #64748b;

    /* Background - Slate (surface colors) */
    --colors-background-100: #ffffff;
    --colors-background-80: #f8fafc;
    --colors-background-60: #f1f5f9;
    --colors-background-40: #e2e8f0;

    /* Status - Error (Red) */
    --colors-error-100: #ef4444;
    --colors-error-80: #f87171;
    --colors-error-60: #fca5a5;
    --colors-error-40: #fecaca;

    /* Status - Success (Emerald) */
    --colors-success-100: #10b981;
    --colors-success-80: #34d399;
    --colors-success-60: #6ee7b7;
    --colors-success-40: #a7f3d0;

    /* Status - Warning (Amber) */
    --colors-warning-100: #f59e0b;
    --colors-warning-80: #fbbf24;
    --colors-warning-60: #fcd34d;
    --colors-warning-40: #fde68a;

    /* Base colors */
    --colors-text-base: #ffffff;
    --colors-border-base: #e2e8f0;

    /* Muted text */
    --colors-text-muted: #94a3b8;

    /* Gradients */
    --colors-gradient-primary-0: #4f46e5;
    --colors-gradient-primary-100: #7c3aed;

    --colors-gradient-secondary-0: #7c3aed;
    --colors-gradient-secondary-100: #a855f7;
  }

  /* body[data-theme='dark'] {
    --colors-foreground-100: #ffffff;
    --colors-foreground-80: #f1f4f9;
    --colors-foreground-60: #99b3c6;
    --colors-foreground-40: #809fb8;

    --colors-background-100: #05162b;
    --colors-background-80: #394455;
    --colors-background-60: #6a7380;
    --colors-background-40: #9ba1aa;

    --colors-error-100: #ea3a3d;
    --colors-error-80: #ef6165;
    --colors-error-60: #f5a0a2;
    --colors-error-40: #f7b0b1;

    --colors-success-100: #1ad598;
    --colors-success-80: #47ddad;
    --colors-success-60: #76e6c1;
    --colors-success-40: #a4eed6;

    --colors-warning-100: #fab959;
    --colors-warning-80: #fac77a;
    --colors-warning-60: #fbd59b;
    --colors-warning-40: #fde3bd;

    --colors-text-base: #ffffff;
    --colors-border-base: #d9e1e7;

    --colors-primary-gradient-0: var(--colors-primary-100);
    --colors-primary-gradient-100: #7c4ef1;

    --colors-secondary-gradient-0: var(--colors-secondary-100);
    --colors-secondary-gradient-100: #36dae8;
  } */
`;
